import { HistoricalInformation } from '../../historicalInformation';
import { HistoricalInfoProps } from '../../historicalInformation/info';
import { StyledModal } from './styles';
import type { TimeSeries, TimeSeriesDatasetBase } from '@/graphql/types/dimensions';

interface VariableInfoModalProps extends HistoricalInfoProps {
  title: string;
  open: boolean;
  onClose: () => void;
  timeSeries?: TimeSeries<TimeSeriesDatasetBase>;
}

const VariableInfoModal = ({
  title,
  description,
  period,
  source,
  open,
  onClose,
  timeSeries,
}: VariableInfoModalProps) => {
  return (
    <StyledModal open={open} onClose={onClose}>
      <HistoricalInformation
        onCloseModal={onClose}
        variableInfo={{
          title,
          description,
          period,
          source,
        }}
        timeSeries={timeSeries}
      />
    </StyledModal>
  );
};

export { VariableInfoModal };
